import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import MessageStatus from "./MessageStatus";
import DateRangeFilter from "./DateRangeFilter";
import ChannelsFilter from "./ChannelsFilter";
import SentimentFilter from "./SentimentFilter";

export default function FilterTab({
  withMsgStatus = true,
  startDate,
  endDate,
  onDateChange,
  channelGroups,
  selectedChannelGroups,
  onChannelsChange,
  selectedStatus,
  onStatusChange,
  selectedSentiments,
  onSentimentsChange,
  statusCounts,
}) {
  const [isOpen, setIsOpen] = useState(true);

  const toggleOpen = () => setIsOpen((prev) => !prev);

  return (
    <Box sx={{ ...styles.wrapper, ...(isOpen ? {} : styles.wrapperClosed) }}>
      <Button
        sx={{
          ...styles.collapseButton,
          ...(isOpen ? {} : styles.collapseButtonClosed),
        }}
        onClick={toggleOpen}
        aria-expanded={isOpen}
        aria-label={isOpen ? "Collapse filters" : "Expand filters"}
      >
        {isOpen ? (
          <>
            FILTERS
            <ChevronLeftOutlinedIcon />
          </>
        ) : (
          <ChevronRightOutlinedIcon />
        )}
      </Button>

      <Box padding={isOpen ? "0px 8px" : "0px 6px"}>
        {withMsgStatus && (
          <MessageStatus
            selected={selectedStatus}
            onChange={onStatusChange}
            statusCounts={statusCounts}
            collapsed={!isOpen}
          />
        )}
        {isOpen && (
          <>
            <DateRangeFilter
              startDate={startDate}
              endDate={endDate}
              handleChange={onDateChange}
            />
            <ChannelsFilter
              groups={channelGroups}
              selectedLabels={selectedChannelGroups}
              onChange={onChannelsChange}
            />
            <SentimentFilter
              selected={selectedSentiments}
              onChange={onSentimentsChange}
            />
          </>
        )}
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    flex: 1,
    maxWidth: "295px",
    position: "sticky",
    top: "10px",
    backgroundColor: "#ffffff",
    borderRadius: "14px",
  },
  wrapperClosed: {
    flex: "0 0 auto",
    width: "fit-content",
  },
  collapseButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "45px",
    width: "100%",
    fontFamily: "FustatExtraBold",
    fontSize: "12px",
    color: "#98a29a",
    padding: "0px 14px",
    letterSpacing: "0.07em",
  },
  collapseButtonClosed: {
    justifyContent: "center",
    minWidth: 0,
    padding: 0,
    color: "#5c6656",
  },
};
